<template>
  <div class="page page__has-bar">
    <div class="page__bd weui-form">
      <div class="weui-form__text-area" v-if="companyName">
        <h2 class="weui-form__title">{{ companyName }}</h2>
        <h4>感谢您的来访，请先登记</h4>
      </div>
      <div class="weui-form__control-area">
        <custom-layout class="weui-cells" :view-config="customViewConfig">
          <div class="weui-cell" slot="vi_username">
            <div class="weui-cell__hd">
              <label for class="weui-label">您的姓名</label>
            </div>
            <div class="weui-cell__bd">
              <input class="weui-input" type="text" v-model="form.main.vi_username" placeholder="请输入您的姓名" />
            </div>
          </div>
          <div class="weui-cell" slot="vi_mobile">
            <div class="weui-cell__hd">
              <label for class="weui-label">您的手机号</label>
            </div>
            <div class="weui-cell__bd">
              <input class="weui-input" type="text" v-model="form.main.vi_mobile" placeholder="请输入您的手机号" />
            </div>
          </div>
          <qcc-search-box label="您的公司" placeholder="请输入您的公司名称" v-model="form.main.vi_corpname"
            @select="onCompanySelect($event)" ref="qccBox" slot="vi_corpname"></qcc-search-box>
          <div class="weui-cell" slot="vi_job">
            <div class="weui-cell__hd">
              <label for class="weui-label">您的职务</label>
            </div>
            <div class="weui-cell__bd">
              <input class="weui-input" type="text" v-model="form.main.vi_job" placeholder="请输入您的职务" />
            </div>
          </div>
          <div class="weui-cell weui-cell_select weui-cell_select-after" slot="vi_identity">
            <div class="weui-cell__hd">
              <label for class="weui-label">您是我们的</label>
            </div>
            <div class="weui-cell__bd">
              <select class="weui-select" v-model="form.main.vi_identity" placeholder="请选择">
                <option value="1">供应商、潜在供应商</option>
                <option value="2">客户、潜在客户</option>
                <option value="4">服务商、潜在服务商</option>
                <option value="8">代理商、潜在代理商</option>
                <option value="0">其他关系</option>
              </select>
            </div>
          </div>
          <datetime-field label="拜访时间" v-model="form.main.vi_visittime" slot="vi_visittime" />
          <employee-field label="拜访对象" v-model="form.main.vi_obj_name"
            list-url="/api/oa/visit_inner/share_employee/list" :extra-params="employeeParams" @select="onSelectEmployee"
            slot="vi_obj_name" />
          <div class="weui-cell weui-cell_select weui-cell_select-after" slot="vi_reason">
            <div class="weui-cell__hd">
              <label for class="weui-label">拜访事由</label>
            </div>
            <div class="weui-cell__bd">
              <select class="weui-select" v-model="form.main.vi_reason" placeholder="请选择拜访事由">
                <option>礼节拜访</option>
                <option>洽谈业务</option>
                <option>开会</option>
                <option>送货</option>
                <option>面试</option>
                <option>其它</option>
              </select>
            </div>
          </div>
          <custom-field :label="customLabel.vi_text1 || '自定义字段1'" v-model="form.main.vi_text1"
            slot="vi_text1" hidden="true" />
          <custom-field :label="customLabel.vi_text2 || '自定义字段2'" v-model="form.main.vi_text2"
            slot="vi_text2" hidden="true" />
          <custom-field :label="customLabel.vi_text3 || '自定义字段3'" v-model="form.main.vi_text3"
            slot="vi_text3" hidden="true" />
          <custom-field :label="customLabel.vi_text4 || '自定义字段4'" v-model="form.main.vi_text4"
            slot="vi_text4" hidden="true" />
          <custom-field :label="customLabel.vi_text5 || '自定义字段5'" v-model="form.main.vi_text5"
            slot="vi_text5" hidden="true" />
        </custom-layout>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="save">确认</a>
    </div>
  </div>
</template>

<script>
import DatetimeField from "@/components/field/DatetimeField.vue";
import EmployeeField from "@/components/field/EmployeeField.vue";
import QccSearchBox from "@/components/field/QccSearchBox";
import CustomLayout from "@/components/layout/CustomLayout.vue";
import CustomField from "@/components/field/CustomField.vue";
import form from "@/mixins/form.js";
import Finger from "@/util/finger.js";
import Session from '@/util/session';

export default {
  components: {
    DatetimeField,
    EmployeeField,
    QccSearchBox,
    CustomLayout,
    CustomField
  },
  mixins: [form],
  data() {
    var me = this;
    return {
      autoLoadViewConfig: false,
      baseUrl: "/api/oa/visit_inner",
      caller: 'VisitInner',
      xtype: 'oa-visitinner-formpanel',
      form: {
        main: {
          companyId: null,
          vi_username: null,
          vi_mobile: null,
          vi_corpname: null,
          vi_corpcredit: null,
          vi_job: null,
          vi_identity: 0,
          vi_visittime: me.dateFormat(new Date(), "yyyy-MM-dd hh:mm:ss"),
        },
      },
      companyName: null,
      employeeParams: {},
    };
  },
  created() {
    var me = this,
      shareId = me.$route.query.shareId;
    if (shareId) {
      me.employeeParams = { shareId };
      // 二维码信息
      me.getShareInfo(shareId);
    }
    // 客户端标记
    me.initClient();
  },
  methods: {
    /**
     * 获取二维码信息
     */
    getShareInfo(shareId) {
      var me = this;
      me.$ajax({
        url: "/api/oa/visit_inner/share/" + shareId,
      }).then(function (res) {
        var data = res.data;
        if (data) {
          me.form.main.companyId = data.companyId;
          me.companyName = data.companyName;
          // 加载自定义视图设置
          Session.setScopeCompany(data.companyId);
          me.getViewConfig();
        } else {
          me.$weui.topTips("二维码已失效", 3000);
        }
      });
    },
    initClient() {
      var me = this,
        clientId = Finger.get();
      me.form.main.vi_clientid = clientId;
      me.getClientInfo(clientId);
    },
    /**
     * 载入个人信息
     */
    getClientInfo(clientId) {
      var me = this;
      me.$ajax({
        url: "/api/open/account/read/" + clientId,
      }).then(function (res) {
        var data = res.data,
          main = me.form.main;
        if (data) {
          main.vi_username = data.name;
          main.vi_mobile = data.mobile;
          main.vi_corpname = data.corpname;
          main.vi_corpcredit = data.corpcredit;
          main.vi_job = data.job;
          me.$refs.qccBox.keyword = data.corpname;
        }
      });
    },
    save() {
      var me = this,
        main = me.form.main;
      if (!main.vi_username) {
        me.$weui.topTips("请输入您的姓名", 2000);
      } else if (!main.vi_mobile) {
        me.$weui.topTips("请输入您的手机号", 2000);
      } else if (!main.vi_obj_name) {
        me.$weui.topTips("请选择拜访对象", 2000);
      } else if (!main.vi_reason) {
        me.$weui.topTips("请填写拜访事由", 2000);
      } else {
        me.f_save(function (res) {
          me.$router.push({
            name: "OaVisitInnerVisitor",
            params: {
              id: res.data.vi_recordid,
            },
          });
        });
      }
    },
    onSelectEmployee(employee) {
      var me = this,
        main = me.form.main;
      main.vi_obj_id = employee.id;
      main.vi_obj_acid = employee.accountId;
    },
    /**
     * 企业名模糊查询选择
     */
    onCompanySelect(company) {
      var code = company.creditCode;
      if (!code || !code.length) {
        code = company.no;
      }
      this.form.main.vi_corpcredit = code;
    },
  },
};
</script>